export const PRODUCT_GET_REQUEST_SUCESSFULL = "PRODUCT_GET_REQUEST_SUCESSFULL";
export const PRODUCT_GET_REQUEST_LOADING = "PRODUCT_GET_REQUEST_LOADING";
export const PRODUCT_GET_REQUEST_FAILURE = "PRODUCT_GET_REQUEST_FAILURE";


//for getting data after deleted 
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";

// for posting new Product
export const POST_PRODUCT_SUCCESS = "POST_PRODUCT_SUCCESS";

// for updating the values in edit pages
export const PATCH_PRODUCT_SUCCESS = "PATCH_PRODUCT_SUCCESS";